/** 회사 소개 "How it works" 의 단계 — 서비스 개요(CLAUDE.md)의 주문 흐름 그대로다. */
export interface ProcessStep {
  readonly title: string;
  readonly description: string;
}

export const PROCESS_STEPS: readonly ProcessStep[] = [
  { title: '디자인', description: '스토어에서 상품을 고르고 에디터에서 직접 디자인합니다.' },
  { title: '임시 견적', description: '수량을 정하면 구간별 단가로 예상 금액을 바로 확인합니다.' },
  { title: '상담 요청', description: '디자인을 저장하고 상담을 요청합니다.' },
  { title: '확정 견적', description: '운영자가 디자인과 수량을 검토해 확정견적을 발행합니다.' },
  { title: '제작·배송', description: '주문하시면 그때부터 제작해 배송해 드립니다.' },
];
